import { render, staticRenderFns } from "./equipmentInfo.vue?vue&type=template&id=56b0fcb8&scoped=true&"
import script from "./equipmentInfo.vue?vue&type=script&lang=js&"
export * from "./equipmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./equipmentInfo.vue?vue&type=style&index=0&id=56b0fcb8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b0fcb8",
  null
  
)

export default component.exports